import { Paper } from "@mui/material";
import { StyledAutocomplete } from "../../styled/formik";


const AutocompleteNoOptionsPopperComponent = (props) => {
  const anchorEl = props.anchorEl?.parentElement;
  return (
    <StyledAutocomplete.AutocompletePopper open anchorEl={anchorEl} width={anchorEl ? anchorEl.clientWidth : null}>
      <Paper >
        <StyledAutocomplete.NoOptionTextLabel>
          {props.noOptionsText}
        </StyledAutocomplete.NoOptionTextLabel>

      </Paper>
    </StyledAutocomplete.AutocompletePopper>

  );
};

export default AutocompleteNoOptionsPopperComponent;